import FlowBuilder from "../components/Flows/FlowBuilder";

const FlowBuilderPage = () => {
    return (
        <div>
            <FlowBuilder />
        </div>
    )
}

export default FlowBuilderPage;